import {
  Modal,
  Box,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Typography,
  TableContainer,
  Paper, 
  Alert
} from "@mui/material";

const LoadingSendProductModal = ({
  open,
  handleCloseDialog,
  loadingSendProduct,
  sendProduct,
  sendProductResponse,
  marketPlaceName,
  loadingOutwardSendProduct
}) => {
  // Gösterilecek mesajı state değerine göre belirleyelim
  let messageColor = "text.primary";
  let messageText = "";

  if (sendProductResponse && sendProductResponse.state) {
    switch (sendProductResponse.state) {
      case 1:
        messageText = "Başarılı bir şekilde eklendi.";
        messageColor = "success.main";
        break;
      case 2:
        messageText = "Kontrol ediliyor...";
        messageColor = "warning.main";
        break;
      case 3:
        messageText = "Başarılı bir şekilde güncellendi.";
        messageColor = "success.main";
        break;
      case 9:
        messageText = sendProductResponse.message || "Beklenmeyen bir hata oluştu.";
        messageColor = "error.main";
        break;
      default:
        messageText = "Durum bilinmiyor.";
        messageColor = "text.primary";
        break;
    }
  }
  return (
    <Modal
      open={open}
      onClose={loadingSendProduct ? undefined : handleCloseDialog}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          minWidth: 300,
          borderRadius: 2
        }}
      >



        {loadingOutwardSendProduct
? (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      p: 2
    }}
  >
    <Typography variant="h6" sx={{ mb: 2 }}>
    Gönderilecek ürünler hazırlanıyor...
    </Typography>
    <CircularProgress />
  </Box>

) :
        
        
        loadingSendProduct ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              p: 2
            }}
          >
            <Typography variant="h6" sx={{ mb: 2 }}>
              {marketPlaceName} ile bağlantı kuruluyor...
            </Typography>
            <CircularProgress />
          </Box>

        ) : (
          <>
            {messageText && (
              <Typography
                variant="h6"
                component="div"
                sx={{ mb: 2, color: messageColor }}
              >
                {messageText}
              </Typography>
                //<Alert severity="error">{messageText}</Alert>
            )}

            {/* Eğer hata yoksa ya da kontrol aşamasındaysa ürün tablosunu göster */}
            {sendProductResponse && sendProductResponse.state !== 9 && sendProduct && sendProduct.length > 0 ? (
              <TableContainer
                component={Paper}
                sx={{
                  maxHeight: 300, // Yüksekliği istediğiniz değere göre ayarlayabilirsiniz
                  overflow: "auto",
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>Gönderilen Ürünler</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sendProduct.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          {item.productImages && item.productImages.length > 0 ? (
                            <Box
                              component="img"
                              src={item.productImages[0].imageUrl}
                              alt={item.title}
                              sx={{ width: 50, height: 50, objectFit: "contain" }}
                            />
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        <TableCell>{item.title || "-"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ): !messageText&&
            <Alert sx={{mt:2}} severity="error">Ürün Gönderilemedi.</Alert>
            }

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                onClick={handleCloseDialog}
                variant="contained"
                color="primary"
                sx={{ borderRadius: 2 }}
              >
                Kapat
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default LoadingSendProductModal;
